module.exports = __webpack_public_path__ + "media/images/home/marketposters_banner-62b7141f10f72fdf8d866a78f84dd394.png";